import { render } from "./BlogMain.vue?vue&type=template&id=1674dddc&scoped=true&bindings={\"isThumbnail\":\"props\",\"BlogApiBaseUrl\":\"data\",\"isLoading\":\"data\"}"
import script from "./BlogMain.vue?vue&type=script&lang=js"
export * from "./BlogMain.vue?vue&type=script&lang=js"

import "./BlogMain.vue?vue&type=style&index=0&id=1674dddc&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1674dddc"

export default script